<template>
  <footer>
    <div class="footer">
      <div class="container">
        <div class="row medium">
          <div class="col-6 col-sm-3">
            <ul class="list-unstyled">
              <li><router-link :to="{ name: 'home' }">Home</router-link></li>
              <li><router-link :to="{ name: 'about' }">About</router-link></li>
              <li><a href="https://wonder.store/resolute">Blog</a></li>
              <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
              <!-- <li><router-link :to="{ name: 'refer' }">Refer a Friend</router-link></li> -->
              <!-- <li><router-link :to="{ name: 'dashboard' }">Dashboard</router-link></li> -->
              <!-- <li><router-link :to="{ name: 'register' }">Join</router-link></li> -->
            </ul>
          </div>
          <div class="col-6 col-sm-3">
            <ul class="list-unstyled">
              <li><router-link :to="{ name: 'request-proposal' }">New Project</router-link></li>
              <li><router-link :to="{ name: 'login' }">Sign in</router-link></li>
              <!-- <li><a href="#">Terms</a></li>
              <li><a href="#">Privacy Policy</a></li> -->
            </ul>
          </div>
        </div>
        <hr class="space space-sm d-none d-sm-block">
        <div class="row text-right d-block d-sm-none">
          <div class="col">
            <p class="smaller no-margin">
              45-47 Clerkenwell Green, London, EC1R 0EB, UK
            </p>
            <p>
              <a href="tel:+44 3333 444906">+44 3333 444906</a>
            </p>
          </div>
        </div>
        <br>
        <div class="d-flex">
          <p class="mb-0"><a href="https://resolute.partners"><img class="" src="/static/images/icon_gray.svg"></a></p>
          <div class="pl-4">
            <p class="mb-1"><router-link :to="{ name: 'home' }"><img class="" src="/static/images/logo_light.svg"></router-link></p>
            <p class="smaller lh15 mb-0">Made on Earth with passion and purpose.<br>
            &copy; 2023 - 2048. All rights reserved</p>
          </div>
          <div class="flex-grow-1 text-right d-none d-sm-block">
            <p class="smaller no-margin lh15">
              resolute.partners UK
              <br />
              45-47 Clerkenwell Green, London, EC1R 0EB
              <br />
              <!-- Plus X Innovation Hub, Lewes Road, Brighton, BN2 4GL -->
            </p>
            <p>
              <a href="tel:+44 3333 444906">+44 3333 444906</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'app-footer',
  data () {
    return {
      isLoggedIn: this.$store.state.isLogged
    }
  },
  created () {
  }
}
</script>

<style lang="scss"></style>
